import type { CmsBlockDescriptor } from '../store/types'

export const FOOD_BOX_PAGE: CmsBlockDescriptor = {
  contentType: 'cms_page',
  pageUrl: '/food-box',
}

export const HOW_GOUSTO_WORKS_PAGE: CmsBlockDescriptor = {
  contentType: 'cms_page',
  pageUrl: '/food-box/how-it-works',
}

export const MEAL_PLANNING_PAGE: CmsBlockDescriptor = {
  contentType: 'cms_page',
  pageUrl: '/food-box/gousto-menu-and-plans',
}
